module.exports = __webpack_public_path__ + "massage.png?ebcb14f3293751a667edcd01bce04ee8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/upload_images/offers/massage.png
// module id = 106
// module chunks = 13